import axios from "axios";

import { useUserStore } from "@/stores/user";

const serverHttp = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL + "/",
});

serverHttp.interceptors.request.use(
  (config) => {
    // Call useUserStore inside the interceptor to avoid circular dependency
    const userStore = useUserStore();

    const token = config.customToken || userStore.user.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error);
  },
);

export default serverHttp;
